
const AdminProfileItem = ({userProfileName,userProfilePhoneNumber,userProfileCompanyName, userProfileEmail, userProfileCountry , userProfilePassword  }) =>{

        return(
          
                <div className="profile-box-admin">
                    <div className="profile-title">
                        <h3>بيانات الملف الشخصي</h3>
                    </div>
                    <div className="profile-details">
                        <div className="profile-item">
                            <p className="profile-item-title">الإسم</p>
                            <p className="profile-item-info">{userProfileName}</p>
                        </div>
                        <div className="profile-item">
                            <p className="profile-item-title">رقم الجوال</p>
                            <p className="profile-item-info">{userProfilePhoneNumber}</p>
                        </div>
                        <div className="profile-item">
                            <p className="profile-item-title">اسم الشركة</p>
                            <p className="profile-item-info">{userProfileCompanyName}</p>
                        </div>
                        <div className="profile-item">
                            <p className="profile-item-title">البريد الالكتروني</p>
                            <p className="profile-item-info">{userProfileEmail}</p>
                        </div>
                        <div className="profile-item">
                            <p className="profile-item-title">البلد</p>
                            <p className="profile-item-info">{userProfileCountry}</p>
                        </div>
                        <div className="profile-item">
                            <p className="profile-item-title">كلمه المرور</p>
                            <p className="profile-item-info">{userProfilePassword}</p>
                        </div>
                    </div>
                </div>
           
                        
            
        );
       
 }
export default AdminProfileItem;


